import React from 'react'
import { ReactComponent as TaskIcon } from './assets/task.svg';
import { ReactComponent as FaqsIcon } from './assets/faqs.svg';
import { ReactComponent as AdminIcon } from './assets/admin.svg';
import { ReactComponent as OrganisationIcon } from '../../assets/organisatioen.svg';
import { ReactComponent as ChatSettingIcon } from '../../assets/chat_setting.svg';
import { ReactComponent as SubscriptionIcon } from '../../assets/subscription.svg';
import { ReactComponent as HistoryIcon } from '../../assets/subscription.svg';
import { useSelector } from 'react-redux';
import { useThemeColor } from '../../hooks/useThemeColor';

const SettingsSidebar = ({ onSelect, selectedComponent }) => {

  const { data } = useSelector((state) => state.admin);
  const { aispaceColor } = useThemeColor();
  
  const isAdmin = data?.user_role === 'ADMIN';
  const isSuperAdmin = data?.user_role === 'SUPER_ADMIN';

  // Only show "Aufgaben verwalten" to admin users
  const showTasks = isAdmin || isSuperAdmin;
  
  // Only show other buttons to super admin users
  const showOtherButtons = isSuperAdmin;

 
  return (
    <div
      className="h-full w-[250px] flex flex-col font-semibold border-r border-gray-200 bg-[#FBFBFF] pl-5 pr-5 pt-10 pb-4"
      style={{ minHeight: '90vh' }}
    >
      {showTasks && (
        <div 
          className={`flex px-4 py-2 text-sm gap-2 items-center text-custom-gray cursor-pointer transition-colors duration-200 mb-2 h-10
            ${selectedComponent === 'tasks' ? 'nav-btn-selected font-bold shadow-md' : 'nav-btn-unselected hover:bg-[#f1f1f1]'}`}
          onClick={() => onSelect('tasks')}
        >
          <span className={selectedComponent === 'tasks' ? 'navbar-icon-selected' : 'navbar-icon'}>
            <TaskIcon fill={selectedComponent === 'tasks' ? aispaceColor : '#5F6368'} />
          </span>
          <span className="navbar-text">Aufgaben verwalten</span>
        </div>
      )}

      {/* Chat functionality is temporarily disabled */}
      {/* {showOtherButtons && (
        <div 
          className={`flex px-4 py-2 text-sm gap-2 items-center text-custom-gray transition-colors duration-200 mb-2 h-10 opacity-50 cursor-not-allowed`}
          // onClick={() => onSelect('chat')} // Disabled - removed onClick
        >
          <span className="navbar-icon">
            <ChatSettingIcon fill="#5F6368" />
          </span>
          <span className="navbar-text">Chat verwalten</span>
        </div>
      )} */}

      {showOtherButtons && (
        <div 
          className={`flex px-4 py-2 text-sm gap-2 items-center text-custom-gray cursor-pointer transition-colors duration-200 mb-2 h-10
            ${selectedComponent === 'admin' ? 'nav-btn-selected font-bold shadow-md' : 'nav-btn-unselected hover:bg-[#f1f1f1]'}`}
          onClick={() => onSelect('admin')}
        >
          <span className={selectedComponent === 'admin' ? 'navbar-icon-selected' : 'navbar-icon'}>
            <AdminIcon fill={selectedComponent === 'admin' ? aispaceColor : '#5F6368'} />
          </span>
          <span className="navbar-text">Administrator</span>
        </div>
      )}

      {showOtherButtons && (
        <div 
          className={`flex px-4 py-2 text-sm gap-2 items-center text-custom-gray cursor-pointer transition-colors duration-200 mb-2 h-10
            ${selectedComponent === 'organizations' ? 'nav-btn-selected font-bold shadow-md' : 'nav-btn-unselected hover:bg-[#f1f1f1]'}`}
          onClick={() => onSelect('organizations')}
        >
          <span className={selectedComponent === 'organizations' ? 'navbar-icon-selected' : 'navbar-icon'}>
            <OrganisationIcon fill={selectedComponent === 'organizations' ? aispaceColor : '#5F6368'} />
          </span>
          <span className="navbar-text">Organisationen</span>
        </div>
      )}

      {showOtherButtons && (
        <div 
          className={`flex px-4 py-2 text-sm gap-2 items-center text-custom-gray cursor-pointer transition-colors duration-200 mb-2 h-10
            ${selectedComponent === 'subscriptions' ? 'nav-btn-selected font-bold shadow-md' : 'nav-btn-unselected hover:bg-[#f1f1f1]'}`}
          onClick={() => onSelect('subscriptions')}
        >
          <span className={selectedComponent === 'subscriptions' ? 'navbar-icon-selected' : 'navbar-icon'}>
            <SubscriptionIcon fill={selectedComponent === 'subscriptions' ? aispaceColor : '#5F6368'} />
          </span>
          <span className="navbar-text">Abonnements</span>
        </div>
      )}

      {showOtherButtons && (
        <div 
          className={`flex px-4 py-2 text-sm gap-2 items-center text-custom-gray cursor-pointer transition-colors duration-200 mb-2 h-10
            ${selectedComponent === 'credit-history' ? 'nav-btn-selected font-bold shadow-md' : 'nav-btn-unselected hover:bg-[#f1f1f1]'}`}
          onClick={() => onSelect('credit-history')}
        >
          <span className={selectedComponent === 'credit-history' ? 'navbar-icon-selected' : 'navbar-icon'}>
            <HistoryIcon fill={selectedComponent === 'credit-history' ? aispaceColor : '#5F6368'} />
          </span>
          <span className="navbar-text">Gutschrift-Historie</span>
        </div>
      )}

      <div className="text-xs text-gray-500 mt-auto mb-20">
        DocAI V2.2<br/>
        © 2025 AI Spaces GmbH
      </div>
    </div>
  )
}

export default SettingsSidebar
